import { render, staticRenderFns } from "./PasienList.vue?vue&type=template&id=b85bee9c"
import script from "./PasienList.vue?vue&type=script&lang=js"
export * from "./PasienList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports